import React from "react";
import "./Maylanh.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

// nếu đã có ContactButtons thì import luôn
// import ContactButtons from "../ContactButtons/ContactButtons";

export default function Maylanh() {
  // ====== DỮ LIỆU MẪU – CÓ THỂ SỬA TÙY Ý ======

  // Các dịch vụ chính (bullet)
  const mainServices = [
    "Kiểm tra xi gas, xử lý xì, bơm gas máy lạnh",
    "Khắc phục máy lạnh chảy nước",
    "Sửa chữa, thay thế block máy lạnh",
    "Khắc phục tình trạng máy lạnh yếu lạnh, không lạnh",
    "Thi công ống đồng, tư vấn lắp đặt máy lạnh đúng kỹ thuật",
    "Bảo trì, vệ sinh máy lạnh định kỳ",
  ];

  const commonFailures = [
    "Máy lạnh vận hành nhưng không lạnh",
    "Máy lạnh bị chảy nước trong phòng",
    "Hơi lạnh yếu, lâu lạnh",
    "Quạt dàn nóng/dàn lạnh không quay",
    "Máy lạnh kêu to",
    "Máy lạnh chớp đèn liên tục",
    "Máy đang hoạt động nhưng tự tắt đột ngột",
    "Máy lạnh bị xì gas",
    "Máy lạnh có mùi khó chịu",
    "Máy lạnh không vô nguồn",
  ];

  const advantages = [
    "Đội ngũ kỹ thuật viên sửa máy lạnh chuyên nghiệp, được đào tạo bài bản.",
    "Chính sách bảo hành lên đến 12 tháng, linh kiện chính hãng 100%.",
    "Hỗ trợ khách hàng kiểm tra và báo giá trước khi sửa chữa.",
    "Ưu đãi giảm giá cho khách hàng thân thiết và khách hàng giới thiệu.",
    "Dịch vụ sửa máy lạnh tận nhà 24/7 tại TP.HCM và khu vực lân cận.",
  ];

  // Bảng giá mẫu (bạn thay bằng dữ liệu thật)
  const priceWall = [
    { service: "Xử lý chảy nước", price: "300.000đ" },
    { service: "Sửa board (Mono)", price: "750.000 – 1.050.000đ" },
    { service: "Sửa board (Inverter)", price: "1.050.000 – 1.650.000đ" },
    { service: "Bơm gas R22", price: "300.000 – 400.000đ" },
    { service: "Vệ sinh máy lạnh", price: "200.000đ" },
  ];

  const priceCeil = [
    {
      service: "Xử lý xì tán, bơm gas hoàn toàn (Mono)",
      price: "2.000.000 – 2.650.000đ",
    },
    {
      service: "Xử lý xì tán, bơm gas hoàn toàn (Inverter)",
      price: "2.450.000 – 3.250.000đ",
    },
    { service: "Thay block máy lạnh (Mono)", price: "4.550.000 – 10.200.000đ" },
    { service: "Thay block (Inverter)", price: "5.050.000 – 11.100.000đ" },
    { service: "Vệ sinh máy lạnh", price: "450.000đ" },
  ];

  const districtColumns = [
    [
      "Sửa máy lạnh tại Quận 1",
      "Sửa máy lạnh tại Quận 2",
      "Sửa máy lạnh tại Quận 3",
      "Sửa máy lạnh tại Quận 4",
      "Sửa máy lạnh tại Quận 5",
      "Sửa máy lạnh tại Quận 7",
    ],
    [
      "Sửa máy lạnh tại Quận 8",
      "Sửa máy lạnh tại Quận 9",
      "Sửa máy lạnh tại Quận 10",
      "Sửa máy lạnh tại Quận 11",
      "Sửa máy lạnh tại Quận Gò Vấp",
      "Sửa máy lạnh tại Quận Phú Nhuận",
    ],
    [
      "Sửa máy lạnh tại Quận Tân Bình",
      "Sửa máy lạnh tại Quận Bình Thạnh",
      "Sửa máy lạnh tại Quận Bình Tân",
      "Sửa máy lạnh tại Quận Thủ Đức",
      "Sửa máy lạnh tại Quận Tân Phú",
      "Sửa máy lạnh tại Hóc Môn / Nhà Bè",
    ],
  ];

  // =====================================================

  return (
    <div className="page-wrapper">
      {/* Nếu dùng nút Zalo/Gọi cố định */}
      {/* <ContactButtons /> */}

      {/* HERO */}
      <section className="hero-section">
        <Navbar />
        <div className="container">
          <h1 className="hero-title">
            Dịch vụ Sửa Máy lạnh TPHCM | Thợ sửa chữa chuyên nghiệp tại nhà
          </h1>
          <p className="hero-text">
            Đừng quên rằng việc máy lạnh bị hư hỏng là một vấn đề phổ biến. Hãy
            để chúng tôi giúp bạn giải quyết những bất tiện này với{" "}
            <strong>dịch vụ sửa máy lạnh uy tín</strong>, nhanh chóng và chuyên
            nghiệp tại Thành Phố Hồ Chí Minh. Chỉ với một cuộc gọi, máy lạnh của
            bạn sẽ được kiểm tra và hoạt động tốt như mới.
          </p>

          <a href="tel:0994307835" className="hero-hotline-btn">
            HOTLINE: 0994 307 835
          </a>

          {/* ===== ẢNH HERO: THAY ĐƯỜNG DẪN Ở ĐÂY ===== */}
          <div className="hero-image-wrap">
            <img
              src="/imgml1.jpg" // <-- ĐƯỜNG DẪN ẢNH
              alt="Thợ sửa máy lạnh tại nhà"
            />
          </div>
        </div>
      </section>

      {/* GIỚI THIỆU DỊCH VỤ + ẢNH */}
      <section className="section">
        <div className="container section-split">
          <div className="section-text">
            <h2>Các dịch vụ sửa máy lạnh tại Điện Lạnh Sài Gòn</h2>
            <p>
              Trung tâm Điện lạnh Sài Gòn cung cấp đa dạng dịch vụ sửa máy lạnh
              cho mọi thương hiệu, bao gồm:
            </p>
            <ul>
              {mainServices.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          {/* ===== ẢNH SPLIT: THAY ĐƯỜNG DẪN Ở ĐÂY ===== */}
          <div className="section-image">
            <img
              src="/imgml2.jpg" // <-- ĐƯỜNG DẪN ẢNH
              alt="Kỹ thuật viên kiểm tra máy lạnh"
            />
          </div>
        </div>
      </section>

      {/* NHỮNG HƯ HỎNG THƯỜNG GẶP + CTA */}
      <section className="section gray-bg">
        <div className="container">
          <h2>Những hư hỏng thường gặp trên máy lạnh</h2>
          <ul>
            {commonFailures.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="center-cta">
            <a href="tel:0994307835" className="hero-hotline-btn">
              GỌI NGAY: 0994 307 835
            </a>
          </div>
        </div>
      </section>

      {/* ƯU ĐIỂM + ẢNH */}
      <section className="section">
        <div className="container section-split reverse">
          <div className="section-image">
            <img
              src="/imgml3.jpeg" // <-- ĐƯỜNG DẪN ẢNH
              alt="Ưu điểm dịch vụ sửa máy lạnh"
            />
          </div>
          <div className="section-text">
            <h2>Ưu điểm Dịch Vụ Sửa Máy Lạnh của Điện Lạnh Sài Gòn</h2>
            <p>
              Nổi tiếng với đội ngũ kỹ thuật viên chuyên môn cao, chúng tôi luôn
              nỗ lực mang đến cho khách hàng dịch vụ tốt nhất:
            </p>
            <ul>
              {advantages.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Nếu bạn cần một đơn vị sửa máy lạnh uy tín, hãy liên hệ Điện Lạnh
              Sài Gòn qua hotline{" "}
              <strong style={{ color: "#0c7a26" }}>0842 294 842</strong> để được
              hỗ trợ nhanh nhất.
            </p>
          </div>
        </div>
      </section>

      {/* BẢNG GIÁ TREO TƯỜNG */}
      <section className="section gray-bg">
        <div className="container">
          <h2>Bảng giá dịch vụ sửa máy lạnh treo tường (1HP – 2.5HP)</h2>

          <div className="table-wrapper">
            <table className="price-table">
              <thead>
                <tr>
                  <th>DỊCH VỤ SỬA MÁY LẠNH</th>
                  <th>ĐƠN GIÁ (VNĐ)</th>
                </tr>
              </thead>
              <tbody>
                {priceWall.map((row) => (
                  <tr key={row.service}>
                    <td>{row.service}</td>
                    <td>{row.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="center-cta">
            <a href="tel:0994307835" className="hero-hotline-btn">
              GỌI THỢ ĐẾN NGAY
            </a>
          </div>
        </div>
      </section>

      {/* BẢNG GIÁ ÂM TRẦN – TỦ ĐỨNG */}
      <section className="section">
        <div className="container">
          <h2>Bảng giá sửa máy lạnh Âm trần – Áp trần – Tủ đứng</h2>

          <div className="table-wrapper">
            <table className="price-table">
              <thead>
                <tr>
                  <th>DỊCH VỤ SỬA MÁY LẠNH</th>
                  <th>ĐƠN GIÁ (VNĐ)</th>
                </tr>
              </thead>
              <tbody>
                {priceCeil.map((row) => (
                  <tr key={row.service}>
                    <td>{row.service}</td>
                    <td>{row.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="center-cta">
            <a href="tel:0994307835" className="hero-hotline-btn">
              GỌI THỢ SỬA MÁY LẠNH SÀI GÒN
            </a>
          </div>
        </div>
      </section>

      {/* LƯU Ý + ẢNH */}
      <section className="section gray-bg">
        <div className="container">
          <h3>Lưu ý:</h3>
          <ul>
            <li>Bảng giá bao gồm công thợ thi công trực tiếp sửa máy lạnh.</li>
            <li>
              Giá đã bao gồm chi phí vật tư cơ bản, chưa bao gồm các chi phí
              phát sinh đặc biệt (nếu có).
            </li>
            <li>
              Giá có thể thay đổi tùy theo vị trí lắp đặt, cấu hình và tình
              trạng thực tế của máy lạnh.
            </li>
          </ul>

          <div className="section-image single">
            <img
              src="/images/imgml4.jpg" // <-- ĐƯỜNG DẪN ẢNH
              alt="Kỹ thuật viên phục vụ khách hàng"
            />
          </div>
        </div>
      </section>

      {/* BẢNG ƯU ĐÃI + DANH SÁCH KHU VỰC */}
      <section className="section">
        <div className="container">
          <div className="benefit-table">
            <div className="benefit-row">
              <span>✅ HOTLINE</span>
              <span>☎ 0994 307 835</span>
            </div>
            <div className="benefit-row">
              <span>✅ Dịch Vụ</span>
              <span>🌟 Uy Tín – Chuyên Nghiệp</span>
            </div>
            <div className="benefit-row">
              <span>✅ Bảo Hành</span>
              <span>🔴 Dài Hạn</span>
            </div>
            <div className="benefit-row">
              <span>✅ Hỗ Trợ</span>
              <span>📍 TP.HCM và vùng lân cận</span>
            </div>
          </div>

          <h2>Gọi Sửa máy lạnh tận nhà nhanh chóng</h2>
          <p>Bấm gọi chi nhánh gần bạn để được phục vụ tốt nhất!</p>

          <div className="district-grid">
            {districtColumns.map((col, idx) => (
              <div className="district-col" key={idx}>
                {col.map((item) => (
                  <a href="tel:0994307835" key={item} className="district-link">
                    {item}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
}
